import React from "react";
import Questions from "./Questions";
import Answers from "./Answers";
import Correct from "./Correct";
import Incorrect from "./Incorrect";
import FinalScope from "./FinalScope";
import "./Survey.css";
import { updateSurvey } from "../../store/actions/surveyUpdate";
import { compileQuestions } from "../../store/actions/surveyQAction";
import { appendAnswer } from "../../store/actions/collectedAnswers";
import { showToast, clearStates } from "../../store/actions/toastAction";
import { connect } from "react-redux";
import firebase from "../../store/firebase";
import {
  UPDATE_SURVEY,
  SURVEY_Q_LIST,
  COLLECT_ANSWER,
  SHOW_TOAST
} from "../../store/actions/types";
import {
  getDifficultyInfo,
  getMaxRetryAttempts,
  validateMinimumQuestions
} from "../../utils/test_utils";
import {
  saveTestAttempt,
  getTestAttempt,
  updateTestAttempt
} from "../../store/actions/testAttemptActions";
//import { addMorePoints } from '../../store/actions/freshCardActions'
//import { appendTest } from "../../store/actions/collectTestResults";
class Survey extends React.Component {
  constructor(props) {
    super(props);
    //this.props.letgoPic(true);
    this.state = {
      counterCorrectAnswers: 0,
      counterIncorrectAnswers: 0,
      questionNumber: -1,
      surveyid: this.props.surveyid, 
      typeofSurvey: this.props.typeofSurvey,
      real_companyID: this.props.real_companyID,
      companyID: this.props.companyID,
      size: this.props.size,
      surveysArr: [],
      varQuestion: '',
      // New section tracking
      sections: this.props.sections || [],
      answeredQuestions: new Set(),
      currentSectionIndex: 0,
      questionsStructure: [], // Will hold the mapping of questions to sections
      // Difficulty and retry tracking
      selectedDifficulty: 'basic', // Default to basic, will be updated when user selects
      currentAttempt: this.props.currentAttempt || 1,
      maxAttempts: getMaxRetryAttempts('basic') + 1, // Default to basic (2 retries + 1 = 3 attempts)
      difficultyLocked: this.props.difficultyLocked || false,
      testStarted: false,
      // Test attempt tracking (prevents difficulty changes via refresh)
      existingAttempt: null,
      loadingAttempt: true,
      attemptCheckComplete: false,
      retriesExhausted: false,
      blockTestStart: false
    };
   
   

    //const { survey_Q_list } = this.props;
    this.checkingCorrectAnswer = this.checkingCorrectAnswer.bind(this);
    this.checkingCorrectAnswerx = this.checkingCorrectAnswerx.bind(this);
    this.jumpToQuestion = this.jumpToQuestion.bind(this);
    this.resetTest = this.resetTest.bind(this);
    this.onDifficultySelected = this.onDifficultySelected.bind(this);
  }

  // Handle difficulty selection from Answers component
  onDifficultySelected = async (difficulty) => {
    
    
    
    const maxAttempts = getMaxRetryAttempts(difficulty) + 1; // +1 for initial attempt
    
    // Save test attempt to database to prevent difficulty changes via refresh
    try {
      const attemptData = await this.props.saveTestAttempt({
        surveyid: this.props.surveyid,
        personid: this.props.personid,
        companyID: this.props.companyID,
        real_companyID: this.props.real_companyID,
        difficulty: difficulty,
        maxAttempts: maxAttempts,
        attemptNumber: this.state.existingAttempt ? this.state.currentAttempt : 1
      });
      
      
      
      this.setState({
        selectedDifficulty: difficulty,
        maxAttempts: maxAttempts,
        difficultyLocked: true, // Lock difficulty after first selection
        testStarted: true,
        existingAttempt: attemptData
      });
      
      
      
      
      
      
    } catch (error) {
      
      
      // Still proceed with local state but warn user
      this.setState({
        selectedDifficulty: difficulty,
        maxAttempts: maxAttempts,
        difficultyLocked: true,
        testStarted: true
      });
      
      alert('⚠️ Unable to save test attempt. Please check your connection and try again.');
    }
  }

  // Method to reset test state for retakes
  resetTest = () => {
    
    
    // Check if retries are allowed
    if (this.state.currentAttempt >= this.state.maxAttempts) {
      
      return false;
    }
    
    // Increment attempt count and reset test state (but keep difficulty settings)
    this.setState({
      counterCorrectAnswers: 0,
      counterIncorrectAnswers: 0,
      questionNumber: -1,
      answeredQuestions: new Set(),
      currentAttempt: this.state.currentAttempt + 1
    });
    
    
    
    
    return true;
  }

  // Check if retries are available based on difficulty and current attempt
  canRetry = () => {
    // First check if the difficulty allows retries at all
    const maxRetryAttempts = getMaxRetryAttempts(this.state.selectedDifficulty);
    
    
    
    // Advanced difficulty (0 retries): No retries allowed ever
    if (maxRetryAttempts === 0) {
      
      return false;
    }
    
    // For basic (2 retries) and intermediate (1 retry): Check if attempts are left
    const canRetry = this.state.currentAttempt < this.state.maxAttempts;
    
    return canRetry;
  }

  // Get retry information for display
  getRetryInfo = () => {
    const maxRetryAttempts = getMaxRetryAttempts(this.state.selectedDifficulty);
    
    const retryInfo = {
      currentAttempt: this.state.currentAttempt,
      maxAttempts: this.state.maxAttempts,
      retriesLeft: maxRetryAttempts === 0 ? 0 : (this.state.maxAttempts - this.state.currentAttempt),
      canRetry: this.canRetry(),
      difficulty: this.state.selectedDifficulty,
      maxRetryAttempts: maxRetryAttempts
    };
    
    
    
    // Additional validation logging
    if (maxRetryAttempts === 0 && retryInfo.canRetry) {
      
    }
    if (maxRetryAttempts === 1 && retryInfo.retriesLeft > 1) {
      
    }
    if (maxRetryAttempts === 2 && retryInfo.retriesLeft > 2) {
      
    }
    
    return retryInfo;
  }

  componentDidMount() {
    
    
    
    
    
    
    // Check for existing test attempts to prevent difficulty changes via refresh
    this.checkForExistingAttempt();
  }

  // Check for existing test attempts when component loads
  checkForExistingAttempt = async () => {
    
    
    // If the user is the owner/publisher of the test, allow unlimited attempts
    // and do not lock difficulty or block starting the test.
    try {
      const isOwner = this.props && this.props.personid && this.props.publisherid && (this.props.personid === this.props.publisherid);
      if (isOwner) {
        
        this.setState({
          existingAttempt: null,
          difficultyLocked: false,
          retriesExhausted: false,
          loadingAttempt: false,
          attemptCheckComplete: true,
          blockTestStart: false
        });
        return;
      }
    } catch (e) {
      
    }
    
    try {
      const attemptData = await this.props.getTestAttempt({
        surveyid: this.props.surveyid,
        personid: this.props.personid,
        companyID: this.props.companyID,
        real_companyID: this.props.real_companyID
      });

      if (attemptData) {
        
        
        // Calculate max attempts based on existing difficulty
        const maxAttempts = getMaxRetryAttempts(attemptData.difficulty) + 1;
        
        // attemptNumber in database = completed attempts
        // currentAttempt for UI = next attempt to be taken
        const completedAttempts = attemptData.attemptNumber || 0;
        const currentAttempt = completedAttempts + 1; // Next attempt to take
        
        // Check if retries are exhausted
        const retriesExhausted = completedAttempts >= maxAttempts || attemptData.retriesExhausted || attemptData.status === 'retries_exhausted';
        
        
        
        if (retriesExhausted) {
          
          
          // Show error message and block test
          this.setState({
            existingAttempt: attemptData,
            selectedDifficulty: attemptData.difficulty,
            currentAttempt: currentAttempt,
            maxAttempts: maxAttempts,
            difficultyLocked: true,
            retriesExhausted: true,
            loadingAttempt: false,
            attemptCheckComplete: true,
            blockTestStart: true
          });
          
          // Show toast message to user
          this.props.showToast({
            type: 'error',
            message: `❌ No retries left for this test! You've completed ${completedAttempts} of ${maxAttempts} attempt${maxAttempts === 1 ? '' : 's'} for ${getDifficultyInfo(attemptData.difficulty).displayName} difficulty.`,
            pos: 'bottom'
          });
          
        } else {
          
          
          this.setState({
            existingAttempt: attemptData,
            selectedDifficulty: attemptData.difficulty,
            currentAttempt: currentAttempt,
            maxAttempts: maxAttempts,
            difficultyLocked: true,
            retriesExhausted: false,
            loadingAttempt: false,
            attemptCheckComplete: true,
            blockTestStart: false
          });
          
          
          
        }
      } else {
        
        
        this.setState({
          existingAttempt: null,
          difficultyLocked: false,
          loadingAttempt: false,
          attemptCheckComplete: true
        });
      }
    } catch (error) {
      
      
      // On error, allow user to proceed but log the issue
      this.setState({
        loadingAttempt: false,
        attemptCheckComplete: true
      });
    }
  }

   getQ(nrIn) {  
     var returnVal = 'Question not found';
     var nrIn2;

     var x;
     if (this.props.survey_Q_list) {
       const questionKeys = Object.keys(this.props.survey_Q_list);
       
       
       var lenq = parseInt(nrIn)+1;
       
       
       if (lenq <= this.state.size) {
         x = parseInt(nrIn);
         
         if (x < questionKeys.length) {
           nrIn2 = parseInt(x) + 1;
           var questionNumber = String("QandA"+nrIn2); 
           
           

           if (this.props.survey_Q_list[questionNumber] !== undefined) {
               
               returnVal = this.props.survey_Q_list[questionNumber].question || 'Question text missing';
           }
         }
       }
     }
     return returnVal;
    }

    // Extract sections from survey data and create question structure
    extractSections = () => {
      if (!this.props.survey_Q_list) return;
      
      const questionsData = this.props.survey_Q_list;
      const questionsStructure = [];
      
      // Create questions structure from survey data
      Object.keys(questionsData).forEach((questionKey, index) => {
        const question = questionsData[questionKey];
        
        const questionInfo = {
          questionKey,
          questionIndex: index,
          question: question.question,
          sectionId: question.sectionId || 'default',
          sectionName: question.sectionName || 'General'
        };
        
        questionsStructure.push(questionInfo);
      });
      
      // If we have sections from props, use them and map questions to sections
      if (this.props.sections && this.props.sections.length > 0) {
        const sectionsWithQuestionMapping = this.props.sections.map(section => ({
          ...section,
          questions: questionsStructure.filter(q => q.sectionId === section.id)
        }));
        
        this.setState({
          sections: sectionsWithQuestionMapping,
          questionsStructure
        });
      } else {
        // Fallback: group questions by section from question data
        const sectionMap = new Map();
        
        questionsStructure.forEach(questionInfo => {
          const sectionId = questionInfo.sectionId;
          const sectionName = questionInfo.sectionName;
          
          if (!sectionMap.has(sectionId)) {
            sectionMap.set(sectionId, {
              id: sectionId,
              name: sectionName,
              questions: []
            });
          }
          
          sectionMap.get(sectionId).questions.push(questionInfo);
        });
        
        const sections = Array.from(sectionMap.values());
        
        this.setState({
          sections,
          questionsStructure
        });
      }
    }

    // Jump to a specific question (only if not answered yet)
    jumpToQuestion = (questionIndex) => {
      if (!this.state.answeredQuestions.has(questionIndex) && questionIndex !== this.state.questionNumber) {
        this.setState({ questionNumber: questionIndex });
      }
    }

    // Get current question's section info
    getCurrentQuestionSection = () => {
      if (this.state.questionsStructure.length > 0 && this.state.questionNumber >= 0) {
        return this.state.questionsStructure[this.state.questionNumber];
      }
      return null;
    }

    checkingCorrectAnswerx(value) {
      
      
      
      

     //if (value.id) {
        this.setState(prevState => ({
          questionNumber: prevState.questionNumber + 1
        }))
        var params = {
          type: COLLECT_ANSWER,
          surveyDone: value.id +'-'+ this.props.surveyid,
          surveyid: this.props.surveyid,
          companyID: this.props.companyID,
          real_companyID: this.props.real_companyID,
          //groupID: value.id,
          personid: this.props.personid, // this.props.personid,
          questionNr: -1,
          thequestion: this.getQ(this.state.questionNumber),
          questionAnswer: '',
          surveyName: this.props.surveyName
        };
        this.props.appendAnswer(params);       
    };

   checkingCorrectAnswer = (value, correct) => {
    
    
    
    

    // Mark current question as answered
    const newAnsweredQuestions = new Set(this.state.answeredQuestions);
    newAnsweredQuestions.add(this.state.questionNumber);

    const isCorrect = value === correct;
    

    if (isCorrect) {
      this.setState(prevState => {
        const newCorrect = prevState.counterCorrectAnswers + 1;
        
        return {
          counterCorrectAnswers: newCorrect,
          questionNumber: prevState.questionNumber + 1,
          answeredQuestions: newAnsweredQuestions
        };
      });
    } else {
      this.setState(prevState => {
        const newIncorrect = prevState.counterIncorrectAnswers + 1;
        
        return {
          counterIncorrectAnswers: newIncorrect,
          questionNumber: prevState.questionNumber + 1,
          answeredQuestions: newAnsweredQuestions
        };
      });
    }
    
    

      var surveyiDone = this.props.surveyDone;
      var key = "QandA"+this.state.questionNumber;
      

      if (this.props.publisherid !== this.props.personid) { 
        var params = {
          type: COLLECT_ANSWER,
          surveyDone: this.props.surveyDone,
          surveyid: this.props.surveyid,
          companyID: this.props.companyID,
          real_companyID: this.props.real_companyID,
          personid: this.props.personid, 
          questionNr: this.state.questionNumber,
          thequestion: this.getQ(this.state.questionNumber),
          questionAnswer: value
        };
        this.props.appendAnswer(params);
     }
   };

   componentDidUpdate(prevProps) {
     // Extract sections when survey data is loaded or sections props change
     if ((this.props.survey_Q_list && !prevProps.survey_Q_list) || 
         (this.props.sections !== prevProps.sections)) {
       this.extractSections();
     }
   }

  render() {
    if (this.state.questionNumber < this.state.size) {
      
      return (
        // <div className="container">
        <div style={{
          width:'100%', 
          align: 'center'
          }}>
        { this.state.questionNumber ===-1?
        <React.Fragment>
        <Questions 
            key={this.state.surveyid}
            surveyid={this.state.surveyid}
            questionNumber={this.state.questionNumber}
            companyID={this.state.companyID} 
            real_companyID={this.state.real_companyID} 
            personid={this.props.personid}
            checkingCorrectAnswerx={this.checkingCorrectAnswerx}
            onDifficultySelected={this.onDifficultySelected}
            sections={this.state.sections}
            totalQuestions={this.state.size}
            selectedDifficulty={this.state.selectedDifficulty}
            difficultyLocked={this.state.difficultyLocked}
            retryInfo={this.getRetryInfo()}
            thoughtID={this.props.thoughtID}
            loadingAttempt={this.state.loadingAttempt}
            existingAttempt={this.state.existingAttempt}
            attemptCheckComplete={this.state.attemptCheckComplete}
            retriesExhausted={this.state.retriesExhausted}
            blockTestStart={this.state.blockTestStart}
            survey_Q_list={this.props.survey_Q_list}
           // setOpen={this.setOpen} 
            handleClose={this.props.handleClose} 
            />  
        </React.Fragment>
          :  
          <div className="row">
          {/* Section Navigation Sidebar */}
          <div className="col-md-3 col-12" style={{ 
            padding: '10px', 
            backgroundColor: '#f8f9fa', 
            borderRadius: '8px',
            marginRight: '10px',
            marginBottom: '10px',
            maxHeight: '400px',
            overflowY: 'auto'
          }}>
            <h6 style={{ marginBottom: '10px', fontSize: '14px', fontWeight: 'bold' }}>Test Sections</h6>
            {this.state.sections.map((section, sectionIndex) => (
              <div key={section.id} style={{ marginBottom: '15px' }}>
                <div style={{ 
                  fontSize: '12px', 
                  fontWeight: 'bold', 
                  marginBottom: '5px',
                  color: '#495057'
                }}>
                  {section.name}
                </div>
                {section.questions.map((questionInfo, qIndex) => {
                  const isAnswered = this.state.answeredQuestions.has(questionInfo.questionIndex);
                  const isCurrent = this.state.questionNumber === questionInfo.questionIndex;
                  
                  return (
                    <button
                      key={questionInfo.questionKey}
                      onClick={() => this.jumpToQuestion(questionInfo.questionIndex)}
                      disabled={isAnswered}
                      style={{
                        width: '30px',
                        height: '30px',
                        margin: '2px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: isAnswered ? '#28a745' : (isCurrent ? '#007bff' : '#fff'),
                        color: isAnswered || isCurrent ? '#fff' : '#000',
                        fontSize: '12px',
                        cursor: isAnswered ? 'not-allowed' : 'pointer',
                        opacity: isAnswered ? 0.6 : 1
                      }}
                    >
                      {qIndex + 1}
                    </button>
                  );
                })}
              </div>
            ))}
            <div style={{ fontSize: '10px', color: '#6c757d', marginTop: '10px' }}>
              <div>🟢 Answered</div>
              <div>🔵 Current</div>
              <div>⚪ Available</div>
            </div>
          </div>
          
          <div className="col-md-9 col-12">
            <Questions 
                key={this.state.surveyid}
                surveyid={this.state.surveyid}
                questionNumber={this.state.questionNumber}
                companyID={this.state.companyID} 
                real_companyID={this.state.real_companyID} 
                checkingCorrectAnswer={this.checkingCorrectAnswer}
                checkingCorrectAnswerx={this.checkingCorrectAnswerx}
                onDifficultySelected={this.onDifficultySelected}
                sections={this.state.sections}
                currentQuestionSection={this.getCurrentQuestionSection()}
                totalQuestions={this.state.size}
                selectedDifficulty={this.state.selectedDifficulty}
                difficultyLocked={this.state.difficultyLocked}
                retryInfo={this.getRetryInfo()}
                personid={this.props.personid}
                thoughtID={this.props.thoughtID}
                loadingAttempt={this.state.loadingAttempt}
                existingAttempt={this.state.existingAttempt}
                attemptCheckComplete={this.state.attemptCheckComplete}
              //  setOpen={this.setOpen} 
                handleClose={this.props.handleClose} 
            />
          </div>
          </div>
            }
        </div>
      );
    } else {
      
      return (
        <FinalScope
          counterCorrectAnswers={this.state.counterCorrectAnswers}
          counterIncorrectAnswers={this.state.counterIncorrectAnswers}
          typeofSurvey={this.props.typeofSurvey}
          onTestComplete={this.props.onTestComplete}
          personid={this.props.personid}
          personName={this.props.userdata.firstName}
          personLname={this.props.userdata.lastName}
          companyID={this.props.companyID} 
          real_companyID={this.props.real_companyID}
          companyName={this.props.userdata.companyName} 
          surveyid={this.props.surveyid}
          qlen={this.props.size}
          uid={this.props.userdata.uid}
          points={this.props.userdata.points}
          pointsy={this.props.userdata.pointsy}
          publisherid={this.props.publisherid}
          thoughtType={this.props.thoughtType}
          title={this.props.title}
          subtitle={this.props.subtitle}
          showLeadb={this.props.showLeadb}
          thoughtID={this.props.thoughtID}
          resetTest={this.resetTest}
          testComplexity={this.state.selectedDifficulty}
          difficulty={this.state.selectedDifficulty}
          currentAttempt={this.state.currentAttempt}
          maxAttempts={this.state.maxAttempts}
          retryInfo={this.getRetryInfo()}
          userdata={this.props.userdata}
        />
      );
   }
  }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    update_Survey: state.updateSurvey.update_Survey,
    survey_Q_list: state.surveyQ.survey_Q_list,
    surveyDone: state.collectAnw.surveyDone,
    sgroupid: state.collectAnw.sgroupid
    //collectTest: state.collectTest.collectTest
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateSurvey: params => dispatch(updateSurvey(params)),
    compileQuestions: params => dispatch(compileQuestions(params)),
    appendAnswer: params => dispatch(appendAnswer(params)),
    showToast: params => dispatch(showToast(params)),
    saveTestAttempt: params => dispatch(saveTestAttempt(params)),
    getTestAttempt: params => dispatch(getTestAttempt(params)),
    updateTestAttempt: params => dispatch(updateTestAttempt(params))
   // appendTest: params => dispatch(appendTest(params))
   // addMorePoints: params => dispatch(addMorePoints(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Survey);

